import { gql } from '@apollo/client'

export const RewardTypeInfoFragment = gql`
  fragment RewardTypeInfo on ClaimableRewardTypeInfo {
    decimal
    rewardName
    rewardTokenAddress
    rewardTokenID
    rewardType
    staticAssetKey
    tokenErcType
  }
`

export const TokenVestingHistoryFragment = gql`
  fragment TokenVestingHistory on TokenVestingHistory {
    amount
    claimedAt
    currencyCode
    network
    transactionHash
    walletAddress
  }
`

export const DailyCheckInRewardFragment = gql`
  fragment DailyCheckInReward on DailyCheckInReward {
    rewardType
    rewardID
    quantity
    metaKey
  }
`

export const DailyCheckInShopRewardFragment = gql`
  fragment DailyCheckInShopReward on DailyCheckInShopReward {
    rewardType
    rewardID
    quantity
    metaKey
    itemType
  }
`
